var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoDanger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.60742 3.74532C5.60742 3.5408 5.7732 3.375 5.9777 3.375C6.1822 3.375 6.34798 3.5408 6.34798 3.74532V6.37968C6.34798 6.5842 6.1822 6.75 5.9777 6.75C5.7732 6.75 5.60742 6.5842 5.60742 6.37968V3.74532Z",
    fill: "#E64539"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.9777 7.50937C5.7732 7.50937 5.60742 7.67516 5.60742 7.87968C5.60742 8.0842 5.7732 8.25 5.9777 8.25C6.1822 8.25 6.34798 8.0842 6.34798 7.87968C6.34798 7.67516 6.1822 7.50937 5.9777 7.50937Z",
    fill: "#E64539"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 11.1C8.81665 11.1 11.1 8.81665 11.1 6C11.1 3.18335 8.81665 0.9 6 0.9C3.18335 0.9 0.9 3.18335 0.9 6C0.9 8.81665 3.18335 11.1 6 11.1ZM6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12Z",
    fill: "#E64539"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoDanger);
export default __webpack_public_path__ + "static/media/infoDanger.0f9af961d1eea776518b651d853577e6.svg";
export { ForwardRef as ReactComponent };